"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARE_TEAM = exports.SIMILAR_PROVIDERS = exports.NEUTRAL_PROVIDER_AVATAR_URL = exports.FEMALE_PROVIDER_AVATAR_URL = exports.MALE_PROVIDER_AVATAR_URL = void 0;
exports.MALE_PROVIDER_AVATAR_URL = 'https://cdn.kyruus.com/pm-dev/assets/provider-avatar-male-rectangle.png';
exports.FEMALE_PROVIDER_AVATAR_URL = 'https://cdn.kyruus.com/pm-dev/assets/provider-avatar-female-rectangle.png';
exports.NEUTRAL_PROVIDER_AVATAR_URL = 'https://cdn.kyruus.com/pm-dev/assets/provider-avatar-neutral-rectangle.png';
exports.SIMILAR_PROVIDERS = 'similar_providers';
exports.CARE_TEAM = 'care_team';
//# sourceMappingURL=assets.js.map